import React, { Component } from "react";
import "./AlertConfig.css";
import { Breadcrumb, Alert, PageHeader } from "react-bootstrap";
import ListAlert from "./ListAlert";
import NewAlert from "./NewAlert";
import "../../react-select.min.css";

export default class AlertConfig extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      showAlertSuccess: false,
      showAlertError: false,
      alertMessage: '',
      refreshAlerts: false
    };
  }

  handleAlertSuccess = (message) => {
    var newState = { alertMessage: message.message, showAlertSuccess: true };
    if (message.refresh) {
      newState.refreshAlerts = true;
    }
    this.setState(newState);
    setTimeout(function() { 
      if(this.state.showAlertSuccess){
        this.setState({ showAlertSuccess: false });
      }
    }.bind(this), 3000);
  }

  handleDismissSuccess = () => {
	  this.setState({ showAlertSuccess: false });
  }

  handleAlertError = (message) => {
    this.setState({ alertMessage: message.message, showAlertError: true });
    setTimeout(function() { 
      if(this.state.showAlertError){
        this.setState({ showAlertError: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissError = () => {
	  this.setState({ showAlertError: false });
  }

  render() {
    return (
      <div className="AlertConfig">
        <Breadcrumb>
		      <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
	        <Breadcrumb.Item active>Alertas</Breadcrumb.Item>
		    </Breadcrumb>
      	<PageHeader>
	      Alertas <small>Configuración</small>
	    </PageHeader>
      <NewAlert {...this.props} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
      {
        this.state.showAlertSuccess &&
        <Alert bsStyle="success" onDismiss={this.handleDismissSuccess}>
          <strong>{this.state.alertMessage}</strong>
        </Alert>
      }
      {
        this.state.showAlertError &&
        <Alert bsStyle="danger" onDismiss={this.handleDismissError}>
          <strong>{this.state.alertMessage}</strong>
        </Alert>
      }
      <ListAlert {...this.props} refresh={this.state.refreshAlerts} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/alert/AlertConfig.js